export default {
  "User Experience": {
    title: "User Experience",
    description:
      "User Experience (UX) is the process of creating interaction designs between users and products. Design decisions in UX design are driven by research, data analysis, and test results rather than aesthetic preferences and opinions. UX design encompasses all aspects of the user's perceived experience with a product or website, such as its usability, usefulness, desirability, brand perception, and overall performance.",
    links: [
      {
        iconType: "article",
        title:
          "What is the design process? — and why every designer should know about it",
        href: "https://medium.com/user-experience-design-1/what-is-the-design-process-and-why-every-designer-should-know-about-it-baab017eed82",
      },

      {
        iconType: "book",
        title: "Universal Principles of Design",
        href: "https://www.amazon.com/Universal-Principles-Design-Revised-Updated/dp/1592535879/ref=sr_1_2?crid=2SUZVNW2CCA53&keywords=universal+principles+of+design&qid=1655150221&sprefix=universal+principle%2Caps%2C94&sr=8-2",
      },
      {
        iconType: "book",
        title: "The Design of Everyday Things",
        href: "https://www.amazon.com/The-Design-Everyday-Things-Expanded/dp/0465050654",
      },
      {
        iconType: "article",
        title: "The Best UX resources 2022",
        href: "https://blog.uxtweak.com/best-ux-resources/",
      },
      {
        iconType: "video",
        title: "What Is UX Design? - A Full Overview",
        href: "https://www.youtube.com/watch?v=SRec90j6lTY",
      },
    ],
  },

  "UX Benchmarking": {
    title: "UX Benchmarking",
    description:
      "UX benchmarking is the process of evaluating a product or service’s user experience by using metrics. Benchmarking can be a useful method for generating quantitative comparisons (for example, tracking the time it takes to complete a task before and after a significant change in the user interface).",
    links: [
      {
        iconType: "article",
        title: "Benchmarking UX: Tracking Metrics",
        href: "https://www.nngroup.com/articles/benchmarking-ux/",
      },
      {
        iconType: "article",
        title: "7 Steps to Benchmark Your Product’s UX",
        href: "https://www.nngroup.com/articles/product-ux-benchmarks/",
      },

      {
        iconType: "article",
        title: "The Top 5 UX Benchmarking Tips for Designers",
        href: "https://xd.adobe.com/ideas/process/user-testing/5-ux-benchmarking-tips-for-designers/",
      },

      {
        iconType: "article",
        title: "Usability benchmarking | GitLab",
        href: "https://about.gitlab.com/handbook/engineering/ux/ux-research-training/usability-benchmarking/",
      },
    ],
  },

  "Design Thinking": {
    title: "Design Thinking",
    description:
      "Design thinking is the human-centered approach to innovation in which designers seek to understand users, define problems, and create innovative solutions which you can prototype and test. Design thinking was adapted for business purposes by Faste's Stanford colleague David M. Kelley, who founded the design consultancy IDEO in 1991.",
    links: [
      {
        iconType: "article",
        title: "What is Design Thinking?",
        href: "https://www.ideou.com/blogs/inspiration/what-is-design-thinking",
      },
      {
        iconType: "article",
        title: "Design Thinking Defined",
        href: "https://designthinking.ideo.com/",
      },
      {
        iconType: "article",
        title: "What is Design Thinking and Why Is It So Popular?",
        href: "https://www.interaction-design.org/literature/article/what-is-design-thinking-and-why-is-it-so-popular",
      },
      {
        iconType: "article",
        title: "Design Thinking 101",
        href: "https://www.nngroup.com/articles/design-thinking/",
      },
      {
        iconType: "article",
        title: "The Value of Design Thinking in Business",
        href: "https://www.toptal.com/designers/product-design/design-thinking-business-value",
      },
    ],
  },

  Personas: {
    title: "Personas",
    description:
      "Personas are the fictional characters that represent different user types. Personas are useful in considering the user's needs, goals, motivations, and behaviors and help to guide design decisions about a product and its specific features, interaction, and visual design.",
    links: [
      {
        iconType: "article",
        title: "Personas Make Users Memorable for Product Team Members",
        href: "https://www.nngroup.com/articles/persona/",
      },
      {
        iconType: "article",
        title: "A Closer Look At Personas: What They Are And How They Work",
        href: "https://www.smashingmagazine.com/2014/08/a-closer-look-at-personas-part-1/",
      },
      {
        iconType: "article",
        title: "A Guide To Personas",
        href: "https://medium.com/beakerandflint/personas-74c4e1c12ee2",
      },
    ],
  },
  "Empathy Map": {
    title: "Empathy Map",
    description:
      "Empathy map is the visualization tool that teams use to gain a deeper understanding of users/customers and their behaviors, attitudes, and needs.",
    links: [
      {
        iconType: "article",
        title: "Empathy Mapping: The First Step in Design Thinking",
        href: "https://www.nngroup.com/articles/empathy-mapping/",
      },
      {
        iconType: "article",
        title: "Empathy Mapping: A Guide to Getting Inside a User’s Head",
        href: "https://www.uxbooth.com/articles/empathy-mapping-a-guide-to-getting-inside-a-users-head/",
      },
      {
        iconType: "article",
        title: "Empathy Map – Why and How to Use It",
        href: "https://www.interaction-design.org/literature/article/empathy-map-why-and-how-to-use-it",
      },
    ],
  },
  "Customer Journey Map": {
    title: "Customer Journey Map",
    description:
      "Customer journey maps are used to map the relationship between the customer and the organization over time and across all channels. Design teams use them to see how customer experiences meet customers’ expectations and find areas where designs could be improved.",
    links: [
      {
        iconType: "article",
        title: "Customer Journey Maps",
        href: "https://www.interaction-design.org/literature/topics/customer-journey-map",
      },
      {
        iconType: "article",
        title: "How to Create a Customer Journey Map",
        href: "https://medium.com/choice-hacking/how-to-create-a-customer-journey-map-ffbd580284d7",
      },
      {
        iconType: "article",
        title: "UX Mapping Methods Compared: A Cheat Sheet",
        href: "https://www.nngroup.com/articles/ux-mapping-cheat-sheet/",
      },
    ],
  },
  "Problem Statement": {
    title: "Problem Statement",
    description:
      "Problem statement is the concise description of the problem that needs to be solved. A great definition of a problem statement will guide you and your team to kick-start the ideation process in the right direction.",
    links: [
      {
        iconType: "article",
        title: "What are Problem Statements?",
        href: "https://www.interaction-design.org/literature/topics/problem-statements",
      },
      {
        iconType: "article",
        title: "Problem Statements in UX Discovery",
        href: "https://www.nngroup.com/articles/problem-statements",
      },
      {
        iconType: "article",
        title:
          "Design Problem Statements – What They Are and How to Frame Them",
        href: "https://www.toptal.com/designers/product-design/design-problem-statement",
      },
      {
        iconType: "article",
        title: "User Need Statements: The ‘Define’ Stage in Design Thinking",
        href: "https://www.nngroup.com/articles/user-need-statements",
      },
      {
        iconType: "video",
        title: "User Need Statements in Design Thinking",
        href: "https://www.youtube.com/watch?v=kT0ZqwdPYRM",
      },
      {
        iconType: "article",
        title: "Using “How Might We” Questions to Ideate on the Right Problems",
        href: "https://www.nngroup.com/articles/how-might-we-questions/",
      },
      {
        iconType: "article",
        title: "What are 5 Whys?",
        href: "https://www.interaction-design.org/literature/topics/5-whys",
      },
    ],
  },
  "User Stories": {
    title: "User Stories",
    description: "aa",
    links: [
      {
        iconType: "video",
        title: "UX title",
        href: "https://uxplanet.org/product-design-methods-mind-map-f6511820a7d5",
      },
    ],
  },
  "Content Strategy": {
    title: "Content strategy",
    description:
      "Content Strategy is the process of planning, creation, delivery, and management of content. Ensuring that content is useful, usable, well structured, and easily found is vital for improving the user experience of a product.",
    links: [
      {
        iconType: "article",
        title:
          "Why Content Is Such A Fundamental Part Of The Web Design Process",
        href: "https://www.smashingmagazine.com/2021/04/content-fundamental-part-web-design-process/",
      },
      {
        iconType: "article",
        title: "Why We’re Moving From Content Strategy to Content Design",
        href: "https://medium.com/designatmeta/why-were-moving-from-content-strategy-to-content-design-e288a70169b8",
      },

      {
        iconType: "article",
        title: "Complete Beginner’s Guide to Content Strategy",
        href: "https://www.uxbooth.com/articles/complete-beginners-guide-to-content-strategy/",
      },

      {
        iconType: "article",
        title: "The top 50 UX writing resources of 2020",
        href: "https://uxcontent.com/2020-top-50-ux-writing-resources/",
      },
    ],
  },
  "UX Storytelling": {
    title: "UX Storytelling",
    description:
      "Storytelling is the process of creating stories. This is a powerful tool to use for communicating UX ideas or creating a narrative around the user experience to make a product more engaging.",
    links: [
      {
        iconType: "article",
        title: "How To Use Storytelling In UX",
        href: "https://www.smashingmagazine.com/2022/04/use-storytelling-ux/",
      },
      {
        iconType: "article",
        title: "Content Strategy & Storytelling",
        href: "https://www.smashingmagazine.com/2012/08/content-strategy-storytelling/",
      },
      {
        iconType: "book",
        title: "Storytelling for User Experience",
        href: "https://rosenfeldmedia.com/books/storytelling-for-user-experience/",
      },
      {
        iconType: "article",
        title: "5 Ways to Become a Better Storyteller",
        href: "https://www.ideou.com/blogs/inspiration/5-ways-to-become-a-better-storyteller?_pos=6&_sid=73350121c&_ss=r",
      },
    ],
  },
  Brainstorming: {
    title: "Brainstorming",
    description:
      "Brainstorming is the ideation technique used by design teams or groups of people with different backgrounds for collaborating and generating ideas for solving the defined problem.",
    links: [
      {
        iconType: "article",
        title: "What is Brainstorming?",
        href: "https://www.interaction-design.org/literature/topics/brainstorming",
      },
      {
        iconType: "article",
        title: "14 tips to help you run a successful product design workshop",
        href: "https://www.intercom.com/blog/running-design-workshops/",
      },
      {
        iconType: "article",
        title: "IDEO: Brainstorming Resources",
        href: "https://www.ideou.com/pages/brainstorming-resources",
      },
      {
        iconType: "article",
        title:
          "Affinity Diagrams: How to Cluster Your Ideas and Reveal Insights",
        href: "https://www.interaction-design.org/literature/article/affinity-diagrams-learn-how-to-cluster-and-bundle-ideas-and-facts",
      },
    ],
  },
  "Information Architecture": {
    title: "Information Architecture",
    description:
      "Information architecture is the discipline that focuses on organizing, structuring, and labeling content in an effective and sustainable way.  With a clearly defined architecture, users can quickly find information and complete tasks.",
    links: [
      {
        iconType: "article",
        title: "Information Architecture: Study Guide",
        href: "https://www.nngroup.com/articles/ia-study-guide/",
      },
      {
        iconType: "article",
        title: "The Beginner’s Guide to Information Architecture in UX",
        href: "https://xd.adobe.com/ideas/process/information-architecture/information-ux-architect/",
      },
      {
        iconType: "book",
        title: "Information Architecture: For the Web and Beyond",
        href: "https://www.amazon.com/Information-Architecture-For-Web-Beyond/dp/1491911689",
      },
    ],
  },
  "User Flow": {
    title: "User Flow",
    description:
      "User flows are a great method for segmenting and defining the user experience. They are helpful when a product team works on information architecture and UI design of individual screens, and also when a team wants to evaluate interfaces for identifying possible issues in the existing flow.",
    links: [
      {
        iconType: "article",
        title: "What are User Flows?",
        href: "https://www.interaction-design.org/literature/topics/user-flows",
      },
      {
        iconType: "article",
        title: "Wireflows: A UX Deliverable for Workflows and Apps",
        href: "https://www.nngroup.com/articles/wireflows/",
      },
      {
        iconType: "article",
        title:
          "UX Glossary: Task Flows, User Flows, Flowcharts and some new-ish stuff",
        href: "https://uxplanet.org/ux-glossary-task-flows-user-flows-flowcharts-and-some-new-ish-stuff-2321044d837d",
      },
      {
        iconType: "article",
        title: "User flow is the new wireframe",
        href: "https://uxdesign.cc/when-to-use-user-flows-guide-8b26ca9aa36a",
      },
    ],
  },
  "Mind Map": {
    title: "Mind Map",
    description:
      "Mind Map is the visual thinking tool that provides a structured way to capture and organize ideas and information around a certain topic. This technique is useful when product teams need to brainstorm about users, features, or any other thoughts related to the product.",
    links: [
      {
        iconType: "article",
        title: "Everything you need to know about mind mapping creation",
        href: "https://www.invisionapp.com/inside-design/mind-mapping-creation/",
      },
      {
        iconType: "article",
        title: "Cognitive Maps, Mind Maps, and Concept Maps: Definitions",
        href: "https://www.nngroup.com/articles/cognitive-mind-concept/",
      },

      {
        iconType: "video",
        title: "3 Powerful Visual Mapping Strategies in UX Design",
        href: "https://www.youtube.com/watch?v=X2w6O5TM7rA",
      },
      {
        iconType: "article",
        title: "Gray Matter: What Is a Mind Map in the Design Process?",
        href: "https://www.toptal.com/designers/digital-product-design/what-is-a-mind-map",
      },
    ],
  },
  Sketching: {
    title: "Sketching",
    description:
      "Sketching is the freehand drawing method. It is a very efficient way of communicating design while allowing designers to try out different ideas and iterate them before settling on one.",
    links: [
      {
        iconType: "article",
        title: "Everything You Need to Know About UX Sketching",
        href: "https://www.toptal.com/designers/ux/guide-to-ux-sketching",
      },
      {
        iconType: "article",
        title: "7 reasons for sketching in UX design",
        href: "https://www.invisionapp.com/inside-design/ux-design-sketching/",
      },
      {
        iconType: "article",
        title: "Learn How to Use Sketching as an Ideation Method",
        href: "https://www.interaction-design.org/literature/article/etch-a-sketch-how-to-use-sketching-in-user-experience-design",
      },
    ],
  },
  Wireframing: {
    title: "Wireframing",
    description:
      "Wireframing is the process of creating low-fidelity screens, which allows teams and stakeholders to communicate which entities, components, and pages the app is going to have and how these elements will interact with each other. With wireframes, designers can generate and iterate screens faster before touching UI.",
    links: [
      {
        iconType: "article",
        title: "Sketch, Wireframe, Mockup, and Prototype: Why, When and How",
        href: "https://uxplanet.org/sketch-wireframe-mockup-and-prototype-why-when-and-how-29a25b3157c4",
      },
      {
        iconType: "article",
        title: "Form and Function – A Guide to the Top Wireframe Tools",
        href: "https://www.toptal.com/designers/ui/top-wireframe-tools-guide",
      },
      {
        iconType: "article",
        title: "How To Succeed In Wireframe Design",
        href: "https://www.smashingmagazine.com/2020/04/wireframe-design-success/",
      },
    ],
  },
  Prototyping: {
    title: "Prototyping",
    description:
      "Prototyping is the process in which design teams ideate, experiment with concepts, and bring them to life. At its core, a prototype is the early sample of a product that allows users to visualize or interact with it before a final product is developed. It is useful for discovering new ideas, identifying usability issues, and testing.",
    links: [
      {
        iconType: "article",
        title: "What Is Prototyping?",
        href: "https://xd.adobe.com/ideas/process/ui-design/what-is-prototyping/",
      },
      {
        iconType: "article",
        title: "Design Thinking: Get Started with Prototyping",
        href: "https://www.interaction-design.org/literature/article/design-thinking-get-started-with-prototyping",
      },
      {
        iconType: "article",
        title: "UX Prototypes: Low Fidelity vs. High Fidelity",
        href: "https://www.nngroup.com/articles/ux-prototype-hi-lo-fidelity/",
      },
    ],
  },
  "Usability Test": {
    title: "Usability Test",
    description:
      "Usability testing is conducted to evaluate the usability, intuitiveness, and satisfaction of using a product for the end user. It's useful to conduct it iteratively during the design process because it allows the team to collect users' insights and reduce the number of issues in the user interface.",
    links: [
      {
        iconType: "article",
        title: "Checklist for Planning Usability Studies",
        href: "https://www.nngroup.com/articles/usability-test-checklist/",
      },
      {
        iconType: "article",
        title: "A Comprehensive Guide To User Testing",
        href: "https://www.smashingmagazine.com/2018/03/guide-user-testing/",
      },
      {
        iconType: "article",
        title: "How to Conduct Usability Testing in Six Steps",
        href: "https://www.toptal.com/designers/ux-consultants/how-to-conduct-usability-testing-in-6-steps",
      },
      {
        iconType: "article",
        title: "A Guide to the Art of Guerrilla UX Testing",
        href: "https://medium.springboard.com/a-guide-to-the-art-of-guerrilla-ux-testing-69a1411d34fb",
      },
      {
        iconType: "article",
        title: "All You Need to Know About Iterative Usability Testing",
        href: "https://xd.adobe.com/ideas/process/user-testing/process-user-testing-iterative-usability-testing-best-practices/",
      },
      {
        iconType: "article",
        title:
          "Turning Usability Testing Data into Action without Going Insane",
        href: "https://www.toptal.com/designers/usability-testing/turning-usability-testing-data-into-action",
      },
    ],
  },
  "Human-Computer Interaction": {
    title: "Human-Computer Interaction",
    description:
      "Human-computer interaction (HCI) is a multidisciplinary field of study focusing on the design of computer technology and, in particular, the interaction between humans (the users) and computers.",
    links: [
      {
        iconType: "article",
        title: "Human-Computer Interaction (HCI)",
        href: "https://www.interaction-design.org/literature/topics/human-computer-interaction",
      },
      {
        iconType: "article",
        title: "Complete Beginner’s Guide to Interaction Design",
        href: "https://www.uxbooth.com/articles/complete-beginners-guide-to-interaction-design/",
      },
      {
        iconType: "book",
        title: "The Encyclopedia of Human-Computer Interaction, 2nd Ed.",
        href: "https://www.interaction-design.org/literature/book/the-encyclopedia-of-human-computer-interaction-2nd-ed",
      },

      {
        iconType: "article",
        title: "What is Interaction Design & How Does it Compare to UX?",
        href: "https://xd.adobe.com/ideas/principles/human-computer-interaction/what-is-interaction-design/",
      },
      {
        iconType: "article",
        title: "Interaction design is more than just user flows and clicks",
        href: "https://uxdesign.cc/interaction-design-is-more-than-just-user-flows-and-clicks-4cc37011418c",
      },
    ],
  },

  "Cognitive Psychology": {
    title: "Cognitive Psychology",
    description:
      "Cognitive psychology is the scientific study of mental processes such as attention, language use, memory, perception, problem-solving, creativity, and reasoning. With knowledge of psychology, product designers keep in mind the users' behavior upfront which leads to better user interfaces.",
    links: [
      {
        iconType: "article",
        title: "What is Cognitive Psychology?",
        href: "https://www.interaction-design.org/literature/topics/cognitive-psychology",
      },

      {
        iconType: "book",
        title: "Miller’s Law — Is there a magical number in UX design?",
        href: "https://uxdesign.cc/millers-law-is-there-a-magical-number-in-ux-design-7999f92ef7b8",
      },
      {
        iconType: "article",
        title: "Laws of UX",
        href: "https://lawsofux.com/en/",
      },
      {
        iconType: "article",
        title:
          "5 Cognitive Psychology Theories that Contribute to the Quality of UX Design",
        href: "https://uxmag.com/articles/5-cognitive-psychology-theories-that-contribute-to-the-quality-of-ux-design",
      },
      {
        iconType: "video",
        title: "Psychology Makes You a Better UX Designer (Hoa Loranger)",
        href: "https://www.youtube.com/watch?v=y6fPKi9-ZG8",
      },
    ],
  },

  "Basics & Principles": {
    title: "Basics & Principles",
    description:
      "Visual design principles focus on the aesthetics of a product and its related materials by strategically implementing colors, fonts, images, and other elements. There are 5 main principles defined: scale, visual hierarchy, balance, contrast, and Gestalt principles.",
    links: [
      {
        iconType: "book",
        title: "Universal Principles of Design",
        href: "https://www.amazon.com/Universal-Principles-Design-Revised-Updated/dp/1592535879/ref=sr_1_2?crid=2SUZVNW2CCA53&keywords=universal+principles+of+design&qid=1655150221&sprefix=universal+principle%2Caps%2C94&sr=8-2",
      },
      {
        iconType: "article",
        title: "5 Principles of Visual Design in UX",
        href: "https://www.nngroup.com/articles/principles-visual-design/",
      },
      {
        iconType: "article",
        title: "The Role of Visual Design In User Experience",
        href: "https://xd.adobe.com/ideas/principles/web-design/role-visual-design-user-experience/",
      },
      {
        iconType: "article",
        title: "7 Practical Tips for Cheating at Design",
        href: "https://medium.com/refactoring-ui/7-practical-tips-for-cheating-at-design-40c736799886",
      },
    ],
  },

  "Visual Hierarchy": {
    title: "Visual Hierarchy",
    description:
      "Visual hierarchy is the principle of arranging elements to show their order of importance. Designers structure visual elements and pages to influence users’ perceptions and focus their attention on the important functions and actions.",
    links: [
      {
        iconType: "article",
        title: "What is Visual Hierarchy?",
        href: "https://www.interaction-design.org/literature/topics/visual-hierarchy",
      },

      {
        iconType: "article",
        title: "Visual Hierarchy in UX: Definition",
        href: "https://www.nngroup.com/articles/visual-hierarchy-ux-definition/",
      },
      {
        iconType: "article",
        title: "5 ways to establish visual hierarchy",
        href: "https://bootcamp.uxdesign.cc/5-ways-to-establish-visual-hierarchy-54db8f783175",
      },
      {
        iconType: "article",
        title: "Key Principles of Visual Hierarchy in UX Design",
        href: "https://xd.adobe.com/ideas/process/information-architecture/visual-hierarchy-principles-examples/",
      },
    ],
  },
  "Gestalt Principles": {
    title: "Gestalt Principles",
    description:
      "Gestalt principles are principles/laws of human perception that describe how humans group similar elements, recognize patterns, and simplify complex forms when perceiving objects. Designers use these principles to organize content on websites and other interfaces so it is aesthetically pleasing and easy to understand.",
    links: [
      {
        iconType: "article",
        title: "What are Gestalt Principles?",
        href: "https://www.interaction-design.org/literature/topics/gestalt-principles",
      },
      {
        iconType: "article",
        title:
          "Improve Your Designs With The Principles Of Closure And Figure-Ground (Part 2)",
        href: "https://www.smashingmagazine.com/2016/05/improve-your-designs-with-the-principles-of-closure-and-figure-ground-part-2/",
      },
      {
        iconType: "article",
        title: "Exploring the Gestalt Principles of Design",
        href: "https://www.toptal.com/designers/ui/gestalt-principles-of-design",
      },
      {
        iconType: "article",
        title:
          "Design Principles: Visual Perception And The Principles Of Gestalt",
        href: "https://www.smashingmagazine.com/2014/03/design-principles-visual-perception-and-the-principles-of-gestalt/",
      },
    ],
  },
  "Jobs-to-be-Done": {
    title: "Jobs-to-be-Done",
    description: `Jobs-to-be-Done framework is the approach for developing products based on understanding both the customer’s specific goal ("job") and the thought processes that would lead that customer to use ("hire") a product to achieve their goal.`,
    links: [
      {
        iconType: "book",
        title: "Jobs to be Done: Theory to Practice",
        href: "https://www.amazon.com/gp/product/0990576744/ref=as_li_tl?ie=UTF8&camp=1789&creative=9325&creativeASIN=0990576744&linkCode=as2&tag=business901-20&linkId=2887f0858d61a35595884db7fbe898ad",
      },
      {
        iconType: "article",
        title:
          "8 things to use in “Jobs-To-Be-Done” framework for product development",
        href: "https://uxdesign.cc/8-things-to-use-in-jobs-to-be-done-framework-for-product-development-4ae7c6f3c30b",
      },
    ],
  },
  "User Story": {
    title: "User Story",
    description:
      "User story is the tool used in Agile development to capture a description of a product's functionality from the end-user perspective. The main goal is to describe the type of user, what feature they will use and what value it will bring to them.",
    links: [
      {
        iconType: "article",
        title: "What are User Stories?",
        href: "https://www.interaction-design.org/literature/topics/user-stories",
      },
      {
        iconType: "article",
        title: "User stories with examples and a template",
        href: "https://www.atlassian.com/agile/project-management/user-stories",
      },
      {
        iconType: "video",
        title: "Introduction on how to write User Stories",
        href: "https://www.youtube.com/watch?v=Pn-QMvDTuEY",
      },
      {
        iconType: "article",
        title: "A Guide To Writing Effective User Stories",
        href: "https://medium.com/@george_wilde/a-guide-to-writing-effective-user-stories-658823dec2e0",
      },
    ],
  },
};
